export const icons = [
  'leftsnap',
  'rightsnap',
  'topsnap',
  'bottomsnap',
  'selecticon',
  'line',
  'cancelfullscreen',
  'fullscreen',
  'template',
  '404',
  'apiyun',
  'barGraph',
  'bug',
  'cc',
  'chart',
  'clipboard',
  'component',
  'dashboard',
  'deblocking',
  'design',
  'documentation',
  'drag',
  'edit',
  'email',
  'examination',
  'example',
  'excel',
  'eye',
  'folder',
  'form',
  'forum',
  'gou',
  'guide',
  'help',
  'icon',
  'international',
  'iPad',
  'jinru',
  'language',
  'list',
  'lock',
  'lockOut',
  'logic',
  'message',
  'money',
  'nested',
  'password',
  'PC',
  'people',
  'peoples',
  'phone',
  'qq',
  'return',
  'run',
  'shoppingCard',
  'star',
  'tab',
  'table',
  'theme',
  'tranfer',
  'tree',
  'user',
  'wechat',
  'zip',
  'ctrlcom',
  'property',
  'hide',
  'assembly',
  'layout',
  'imglayout',
  'share',
  'random',
  'verticalcentersnap',
  'levelcentersnap',
  '严重霾',
  '中度霾',
  '中雨-大雨',
  '中雨',
  '中雪-大雪',
  '中雪',
  '冷',
  '冻雨',
  '和风',
  '多云',
  '大暴雨-特大暴雨',
  '大暴雨',
  '大雨-暴雨',
  '大雨',
  '大雪-暴雪',
  '大雪',
  '大雾',
  '大风',
  '小雨-中雨',
  '小雨',
  '小雪-中雪',
  '小雪',
  '少云',
  '平静',
  '强沙尘暴',
  '强浓雾',
  '强阵雨',
  '强雷阵雨',
  '强风-劲风',
  '微风',
  '扬沙',
  '晴',
  '晴间多云',
  '暴雨-大暴雨',
  '暴雨',
  '暴雪',
  '有风',
  '未知',
  '极端降雨',
  '毛毛雨-细雨',
  '沙尘暴',
  '浓雾',
  '浮尘',
  '清风',
  '烈风',
  '热',
  '热带风暴',
  '特大暴雨',
  '特强浓雾',
  '狂爆风',
  '疾风',
  '轻雾',
  '重度霾',
  '阴',
  '阵雨',
  '阵雨夹雪',
  '阵雪',
  '雨',
  '雨夹雪',
  '雨雪天气',
  '雪',
  '雷阵雨',
  '雷阵雨并伴有冰雹',
  '雾',
  '霾',
  '风暴',
  '飓风',
  '龙卷风',
  'sun',
]
